import { VStack, Text } from '@chakra-ui/react';
import { PageContext } from 'components/common/PageContext';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { InAppLayoutVariant } from 'types/Layout';

type registrationLayoutProps = {
  children: React.ReactNode;
  backButtonFn?: () => void;
};

export const RegistrationLayout = ({
  children,
  backButtonFn,
}: registrationLayoutProps): ReactElement => {
  return (
    <PageContext
      title="Registrierung"
      customOnBackClick={backButtonFn}
      variant={InAppLayoutVariant.TERTIARY}
    >
      <VStack width="100%" mt="40px" px={{ base: 'l', md: 0 }}>
        <VStack align="left" gap="15px" width="100%" mb="14px">
          <Text as="h1" textStyle="h1.medium" color="text.primary">
            Account erstellen
          </Text>
          <Text textStyle="body.m.regular" color="text.secondary">
            Du hast schon einen Account?
            <Link to="/auth/login">
              <Text ml="4px" as="span" textStyle="body.m.medium" color="text.info">
                Jetzt einloggen
              </Text>
            </Link>
          </Text>
        </VStack>
        {children}
      </VStack>
    </PageContext>
  );
};
